import React from 'react';
import Typo from '../typo';
import Button from '../button';

const TotalPoints = ({
  totalPoints,
  showLateonBoardInfo,
  hideIcon,
  addCls,
  onClick,
  lateOnboard
}) => {
  return (
    <>
      <div className={`si-totalPoints__wrap ${addCls ? addCls : ''}`}>
        {/* Conditionally render si-lateonBoardInfo */}
        {showLateonBoardInfo && (
          <div className='si-lateonBoardInfo'>
            <Typo component='span' className='lms-lateonboard'></Typo>
          </div>
        )}
        {lateOnboard ? (
          <div className='si-lateonBoardInfo'>
            <i className='lms-lateonboard'></i>
          </div>
        ) : null}

        {typeof totalPoints === 'number' ? (
          <Button
            variant={'primaryLink'}
            icon={hideIcon ? 'lms-chevron-right' : ''}
            onClick={onClick}
          >
            {totalPoints} Pts
          </Button>
        ) : (
          <Button
            variant={'primaryLink'}
            icon={hideIcon ? 'lms-chevron-right' : ''}
            onClick={onClick}
          >
            {totalPoints ? totalPoints : '-'}
          </Button>
        )}
      </div>
    </>
  );
};

export default TotalPoints;
